import { render, staticRenderFns } from "./topBanner.vue?vue&type=template&id=5fc5d24a&"
import script from "./topBanner.vue?vue&type=script&lang=js&"
export * from "./topBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports